/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Floating_No_Other_SpacesInputs */



/**
* | output |
* | --- |
* | "No other spaces available to compare." |
*
* @param {Spaces_Floating_No_Other_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_floating_no_other_spaces = /** @type {((inputs?: Spaces_Floating_No_Other_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Floating_No_Other_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine anderen Spaces zum Vergleichen verfügbar.")
	return /** @type {LocalizedString} */ ("No other spaces available to compare.")
});